import React, { useContext, useEffect, useState } from "react";
import { AdminDashboardContext } from '../../../../../context/AdminDashboardContext.js';

// style
import Style from './AdminDashboardProjectSummary.module.css';

const AdminDashboardProjectSummary = 
({  currentInputValue, 
    projectUpdateName}) => {
    
    const [inputValue, setInputValue] = useState("");
    const [labelValue, ] = useState("");

    const { projectEditable, setUpdateProjectData } = useContext(AdminDashboardContext);

    // update inputValue when currentInputValue changes
    useEffect(() => {
        setInputValue(currentInputValue);
    }, [currentInputValue, projectEditable]);

    // Handle changes to the input value
    const handleChange = (e) => {
        setInputValue(e.target.value);

        setUpdateProjectData(prevState => ({
            ...prevState,
            [projectUpdateName]: e.target.value
        }));
    };

    return (
        <div className={Style.AdminProjectSummaryContainer}>
            <p className={Style.AdminProjectSummaryLabel}>{labelValue}</p>
            <textarea
                className={Style.AdminProjectSummary}
                type="text"
                readOnly={!projectEditable}
                value={inputValue}
                onChange={handleChange}
            />
        </div>
    );
};

export default AdminDashboardProjectSummary;
